import styled from "@emotion/styled";

export const Wrapper = styled.div`
  color: var(--color);
  font-family: var(--font-family-sans);
  background-color: var(--color-base-neutral05);
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;
